<script setup lang="ts">
const featuresSlider = ref(null);
const featuresSwiperSlider = useSwiper(featuresSlider, {
  effect: "slide",
  loop: true,
  autoplay: {
    delay: 3000,
  },
  slidesPerView: 1,
});

const isSliderReady = computed(() => featuresSwiperSlider.instance.value?.initialized || false);

onMounted(() => {
  featuresSwiperSlider.instance.value?.autoplay?.start();
});
</script>

<template>
  <!-- Top Header -->
  <div class="header-top py-1.5 bg-dark-bg text-white px-4">
    <div class="container mx-auto">
      <swiper-container v-show="isSliderReady" ref="featuresSlider" class="sm:hidden">
        <swiper-slide class="inner-wrap">
          <li class="flex items-center justify-center space-x-2">
            <img
              src="assets/images/free-shiping-icon.svg"
              alt="free-shiping-icon"
              class="w-5 h-5"
            />
            <a class="text-white no-underline inline">{{
              $t("header.freeShipping")
            }}</a>
          </li>
        </swiper-slide>
        <swiper-slide class="inner-wrap">
          <li class="flex items-center justify-center space-x-2">
            <img
              src="assets/images/swiss-design.svg"
              alt="swiss-design"
              class="w-5 h-5"
            />
            <a class="text-white no-underline inline">{{
              $t("header.swissDesign")
            }}</a>
          </li>
        </swiper-slide>
        <swiper-slide class="inner-wrap">
          <li class="flex items-center justify-center space-x-2">
            <img
              src="assets/images/quantity-discount-icon.svg"
              alt="quantity-discount-icon"
              class="w-5 h-5"
            />
            <a class="text-white no-underline inline">{{
              $t("header.quantityDiscount")
            }}</a>
          </li>
        </swiper-slide>
        <swiper-slide class="inner-wrap">
          <li class="flex items-center justify-center space-x-2">
            <img
              src="assets/images/deliver-date-icon.svg"
              alt="deliver-date-icon"
              class="w-5 h-5"
            />
            <a class="text-white no-underline inline">{{
              $t("header.deliveryDate")
            }}</a>
          </li>
        </swiper-slide>
      </swiper-container>
      <ul
        class="hidden sm:flex justify-between space-x-4 text-xs font-normal list-none"
      >
        <li class="flex items-center space-x-2">
          <img
            src="assets/images/free-shiping-icon.svg"
            alt="free-shiping-icon"
            class="w-5 h-5"
          />
          <a class="text-white no-underline hidden sm:inline">{{
            $t("header.freeShipping")
          }}</a>
        </li>
        <li class="flex items-center space-x-2">
          <img
            src="assets/images/swiss-design.svg"
            alt="swiss-design"
            class="w-5 h-5"
          />
          <a class="text-white no-underline hidden sm:inline">{{
            $t("header.swissDesign")
          }}</a>
        </li>
        <li class="flex items-center space-x-2">
          <img
            src="assets/images/quantity-discount-icon.svg"
            alt="quantity-discount-icon"
            class="w-5 h-5"
          />
          <a class="text-white no-underline hidden sm:inline">{{
            $t("header.quantityDiscount")
          }}</a>
        </li>
        <li class="flex items-center space-x-2">
          <img
            src="assets/images/deliver-date-icon.svg"
            alt="deliver-date-icon"
            class="w-5 h-5"
          />
          <a class="text-white no-underline hidden sm:inline">{{
            $t("header.deliveryDate")
          }}</a>
        </li>
      </ul>
    </div>
  </div>
</template>
